import * as yup from 'yup';
import { differenceInDays } from 'date-fns';

export const schema = yup.object({
  name: yup.string().notRequired(),
  email: yup.string().trim().email('Please enter a valid email address').required('Email is required').label('Email address').max(255),
  phone: yup.string().trim().required('Phone is required').label('Phone number').max(40),
  qffNumber: yup.string().trim().notRequired(),
  businessNumber: yup.string().trim().notRequired(),
});

export const isFourWeeksAfterCheckout = (checkoutDate) => {
  return differenceInDays(new Date(), new Date(checkoutDate)) >= 28;
};
